import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersTabComponent } from './users-tab.component';
import { UsersTabSearchComponent } from './users-tab-search/users-tab-search.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../material.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {SearchModule} from '../../components/search/search.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { UsersTabSummaryComponent } from './users-tab-summary/users-tab-summary.component';
import {FlexModule} from '@angular/flex-layout';
import { UsersTabDialogComponent } from './users-tab-dialog/users-tab-dialog.component';
import {DividerModule} from '../../components/separator/divider.module';
import {InfraModule} from 'ac-infra';
import { UsersExportDialogComponent } from './users-export-dialog/users-export-dialog.component';

@NgModule({
  declarations: [
      UsersTabComponent,
      UsersTabSearchComponent,
      UsersTabSummaryComponent,
      UsersTabDialogComponent,
      UsersExportDialogComponent
  ],
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        MaterialModule,
        LayoutModule,
        ActionBarModule,
        SearchModule,
        ArmTableModule,
        FlexModule,
        DividerModule,
        InfraModule
    ]
})
export class UsersTabModule { }
